import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistedstate from 'vuex-persistedstate';
import { PERSISTEDSTATE_KEY } from '@/constants';
import modules from './modules';

Vue.use(Vuex);

const plugins = [];
const getstate = (key, paths, storage) => VuexPersistedstate({ key, paths, storage });
plugins.push(getstate(PERSISTEDSTATE_KEY.AUTH, ['common.auth'], window.sessionStorage));
plugins.push(getstate(PERSISTEDSTATE_KEY.USER, ['common.user'], window.localStorage));

/**
 * Commented.by.KWShin.2024.02.01.
 * Vuex Store는 페이지가 reload 될 때 모두 사라져 버린다.
 * 이를 방지하기 위한 용도로 vuex-persistedstate라는 라이브러리를 사용한다.
 * 이 라이브러리는 Vuex Store의 내용을 storage에 넣어주고 새로고침 시 다시 읽어서 store에 넣어준다.
 * - 아래 Vuex.Store 인스턴스에 "plugins: [ VuexPersistedstate(); ]"를 넣어주기만 하면 되는데,
 *   그러면 모든 store의 내용이 모두 storage에 저장되게 되서 문제가 될 수 있다.
 * - 그래서 위와 같이 plugins 변수에 필요한 store 데이터만 어떤 storage에 저장할 지를 지정하여
 *   VuexPersistedstate()의 배열을 만들어
 *   아래와 같이 plugins에 할당한다.
 */
const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules,
  plugins,
});

if (!Reflect.has(store, 'hasModule')) store.hasModule = n => !!(Array.isArray(n) ? n : [n]).reduce((a, i) => (a ? a[i] : a), store.state);

store.registerModules = (n, module) => {
  n = Array.isArray(n) ? n : [n];
  n.reduce((a, m, i) => {
    a.push(m);
    if (!store.hasModule(a)) {
      if (i == n.length - 1) store.registerModule(a, module);
      else store.registerModule(a, { namespaced: true, modules: {} });
    }
    return a;
  }, []);
};

export default store;
